import AcPurchasesOverviewAllTab from './all/all';

export default {
  All: AcPurchasesOverviewAllTab,
};
